﻿window.cBuilderEmailWidgetRGPDNomsociete = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetrgpdnomsociete'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>RGPD:Nom societe</div>").appendTo($DivBt)
        $DivBt.attr("title", "RGPD:<b>Ajouter le nom de la société</b><br/>Pour être conforme à la RGPD, vous devez rajouter le nom de la société qui envoi le mail. La phrase type est <i>'Ce message vous est envoye par [société]'</i>.")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetrgpdnomsociete'>")
        $("<!-- DEBUT RGPD nom societe -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("p")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)

        if (!option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par") || option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par").length == 0) {
            var dataSociete = option.bddCtrl.mGetArray("societe")[0]
            if (dataSociete) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par", dataSociete.nom)
            }
        }
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget RGPDpopsoftAnomsociete' nom_societe=''/>").appendTo($Tr)
        $Td.empty()
            .append(document.createTextNode("Vous recevez ce message de "))
            .append($("<b/>").text(option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par")))
            .attr("nom_societe", option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par"));

        $("<!-- FIN RGPD nom societe -->").appendTo(option.element)
    }

    this.nom = "RGPD:Nom société"
    this.icone = "fas fa-building-columns"

    function mGetTdContenu() { return $(option.element.find(".contenuwidget")[0]) }

    var dxBuilderSaisieHtml = null
    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div/>").appendTo(contentElement).dxTextBox({
            labelMode: "floating",
            label: "Nom société",
            bddCtrl: option.bddCtrl,
            value: option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par"),
            onValueChanged: function (e) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par", e.value)
                mGetTdContenu().empty()
                    .append(document.createTextNode("Vous recevez ce message de "))
                    .append($("<b/>").text(option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par")))
                    .attr("nom_societe", option.bddCtrl.paraAppli.mGetPara("nom_societe_rgpd_envoyer_par"));
                option.onValueChanged()
            }
        }).dxTextBox("instance")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()
        dxBuilderSaisieHtml = null

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value != null && value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                option.parent.mGetContenuWidget().css(prop, jsonCssData[prop])
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, jsonCssData[prop])
            } else {
                option.parent.mGetContenuWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
            }
        }
    }

}